import React, {Fragment, useRef, useState} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";
import {withStyles} from "@material-ui/core/styles";
import {Tooltip} from "@material-ui/core";
import StringToJSX from "../../../functions/StringToJsx";
import DataGrid from "../../../controls/DataGrid";


const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const MessageExchangeGrid = (_props) => {
  const {isAuthenticated} = useAuth0();
  const props = {
    ..._props
  }
  const [state, setState] = useState({
    canEdit: props.canEdit||false,
  });

  const messages = props.messages;
  const dataGridRef = useRef();

  const renderMessage = (params) => {
    const messageParts = params.data.message.split("\n");
    return (
      // <HtmlTooltip
      //   rowData={{}}
      //   title={ messageParts.map(part => { return <div><span>{part}</span><br/></div> }) }
      // >
      <div style={{lineHeight: 1, fontSize:"12px", fontFamily: "monospace" }}>
        { messageParts.map((part, i) => { return <div key={i} ><span>{part}</span><br/></div>}) }
      </div>

      // </HtmlTooltip>
    )
  }

  const getColumns = (props) => {
    const baseColumn = {
      options: {
        cellStyle: { fontSize:14 },
      },
      editable: props.canEdit,
      suppressMenu: true,
      suppressNavigable: true
    };

    return [
      {
        ...baseColumn,
        headerName: "Time Stamp",
        field: "messageDate",
        width: 160,
        valueFormatter: (params)=> {
          return params.value ? moment.utc(params.value).format("DD/MM/YYYY HH:mm") : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Request / Response",
        field: "action",
        width: 350,
        autoHeight: true,
        wrapText: true,
      },
      {
        ...baseColumn,
        headerName: "Slot Status",
        field: "status",
        width: 150,
        autoHeight: true,
        wrapText: true
      },
      {
        ...baseColumn,
        headerName: "Message",
        field: "message",
        flex: 1,
        autoHeight: true,
        wrapText: true,
        cellRenderer: {
          component: "renderMessage",
        },
      },
    ];
  };

  const dataGridComponents = {renderMessage};

  return (isAuthenticated &&
    <div style={{width: props.width?props.width:"100%", ...props.style}}>
      <DataGrid
        title="MessageExchangeGrid"
        ref={dataGridRef}
        columns={getColumns({canEdit: state.canEdit})}
        rows={messages}
        height={props.height||"300px"}
        components={dataGridComponents}
        options={{
          singleClickEdit: true,
          editType:'fullRow',
          onCellValueChanged: ()=>{}, //prevent default onCellValueChanged
          defaultColDef: {
            editable: false,
            resizable: false,
          }
        }}
      />
    </div>
  );

}

export default MessageExchangeGrid;
